import React,{ useState, useEffect } from 'react';
import { Player, ControlBar } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css"; 
import { Spinner } from 'react-bootstrap';

export const Video = (props) => {
    const [data, setdata] = useState([]);
    const [loaded, setloaded] = useState(false);

    useEffect(() => {
        if(props.data.length !== 0) {
          setdata(props.data);
          setloaded(true);
        }
      }, [props]);

    function renderVideo() {
        return(
            <div className='embedvideo' dangerouslySetInnerHTML={{__html: data.current.movie}} />
        )
    }

    let content = loaded
        ? renderVideo()
        : <Spinner/>

    return(
        <>
        {content}
            {/* <Player
                playsInline
                autoPlay
                loop
                muted
                poster="/assets/poster.png"
                src="/assets/race.mp4"
            >
                <ControlBar
                    disableDefaultControls={true}
                    className='hidden'
                />
                </Player> */}
        </>
    );
}